import {
  GET_COMPANY_NOTIFICATIONS_REQUEST,
  GET_COMPANY_NOTIFICATIONS_RESPONSE,
  SET_COMPANY_NOTIFICATION_SEEN,
  REPLACE_COMPANY_NOTIFICATION,
  GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST,
  GET_COMPANY_DROPDOWN_NOTIFICATIONS_RESPONSE,
  SET_COMPANY_UNSEEN_NOTIFICATIONS_COUNT,
  ADD_COMPANY_PUSH_NOTIFICATION,
} from "./types";

export const getCompanyNotificationsRequest = (payload) => ({
  type: GET_COMPANY_NOTIFICATIONS_REQUEST,
  payload,
});

export const getCompanyNotificationsResponse = (payload) => ({
  type: GET_COMPANY_NOTIFICATIONS_RESPONSE,
  payload,
});

export const setCompanyNotificationSeenRequest = (payload) => ({
  type: SET_COMPANY_NOTIFICATION_SEEN,
  payload,
});

export const replaceCompanyNotification = (payload) => ({
  type: REPLACE_COMPANY_NOTIFICATION,
  payload,
});

export const getCompanyDropdownNotificationsRequest = (payload) => ({
  type: GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST,
  payload,
});

export const getCompanyDropdownNotificationsResponse = (payload) => ({
  type: GET_COMPANY_DROPDOWN_NOTIFICATIONS_RESPONSE,
  payload,
});

export const setCompanyUnseenNotificationsCount = (payload) => ({
  type: SET_COMPANY_UNSEEN_NOTIFICATIONS_COUNT,
  payload,
});

export const addCompanyPushNotification = (payload) => ({
  type: ADD_COMPANY_PUSH_NOTIFICATION,
  payload,
});
